<template>
  <v-row class="pt-5 px-3 mt-4">
    <span class="font-weight-bold font-size-base align-self-center pb-3 pr-3 pl-1">Filter:</span>
    <v-col data-testid="chart-grid-warehouse-select-container" class="pb-0">
      <warehouse-multi-select
        :is-flex="false"
        hide-icon
        auto-select-all
        ref="reportingWarehouseSelect"
        dense
        placeholder="Warehouses"
        label="Warehouses"
        :joins="['docks||id,name']"
        :select-fields="['id,name,facilityNumber']"
        @input="
          ws =>
            persistLastSelectedData(
              'warehouseIds',
              ws?.map(w => w.id)
            )
        "
        :auto-select-by-ids="getLastSelectedWarehouseIds()"
        v-model="filters.selectedWarehouses"
        show-store-number></warehouse-multi-select>
    </v-col>
    <v-col v-if="includeDockSelect">
      <basic-dock-select
        ref="dock-select"
        dense
        label="Docks"
        multiple
        auto-select-all
        :hide-inactive-docks="false"
        :select-fields="['id,name,isActive,loadTypeIds']"
        v-model="filters.selectedDocks"
        :warehouse-ids="selectedWarehouseIds"
        hide-icon
        :disabled="!filters.selectedWarehouses.length">
      </basic-dock-select>
    </v-col>
    <v-col class="d-flex align-center pt-0 pb-0">
      <date-range
        :disabled="filters.showAllTime"
        input-max-width="20rem"
        v-model="dateRange"
        v-if="dateRangesReady"
        :initial-range="dateRange"></date-range>
    </v-col>
    <v-spacer v-if="includeLayoutToggle"></v-spacer>
    <v-btn-toggle v-model="layout" tile color="secondary" group v-if="includeLayoutToggle">
      <v-btn value="stacked">
        <span class="hidden-sm-and-down">Stacked</span>
        <v-icon right>mdi-view-sequential</v-icon>
      </v-btn>
      <v-btn value="grid">
        <span class="hidden-sm-and-down">Grid</span>
        <v-icon right>mdi-view-grid</v-icon>
      </v-btn>
    </v-btn-toggle>
  </v-row>
</template>

<script>
import dateRangeFilterMixin from '@/modules/insights/components/mixins/dateRangeFilterMixin';
import { isArray, isObject } from 'class-validator';
import persistFilterMixin from '@/modules/insights/components/mixins/persistFilterMixin';

export default {
  name: 'InsightsFilterBar',
  mixins: [dateRangeFilterMixin, persistFilterMixin],
  props: {
    includeLayoutToggle: {
      type: Boolean,
      required: false,
      default: false
    },
    includeDockSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectionPersistKey: {
      type: String,
      default: 'nova_insights_warehouse'
    }
  },
  data() {
    return {
      layout: 'stacked',
      initialLookbackDays: 6,
      warehousesReady: false,
      filters: {
        showAllTime: false,
        selectedWarehouses: [],
        dateRange: [],
        selectedDocks: []
      }
    };
  },
  computed: {
    selectedWarehouseIds() {
      let warehouseIds = [];
      if (isObject(this.filters.selectedWarehouses)) {
        warehouseIds = [this.filters.selectedWarehouses?.id];
      } else if (isArray(this.filters.selectedWarehouses)) {
        warehouseIds = this.filters.selectedWarehouses.map(wh => {
          return typeof wh === 'string' ? wh : wh.id;
        });
      }
      return warehouseIds;
    }
  },
  methods: {
    getLastSelectedWarehouseIds() {
      const filterData = this.getPersistedFilterData();
      if (filterData?.warehouseIds) {
        return filterData.warehouseIds;
      }
    }
  },
  beforeMount() {
    this.initDateRanges();
  },
  watch: {
    layout() {
      this.$emit('layoutChange', this.layout);
    },
    'filters.selectedWarehouses'() {
      this.warehousesReady = true;
      if (this.dateRangesReady) {
        this.$emit('ready');
      }
    },
    dateRangesReady() {
      this.filters.dateRange = this.dateRange;
      if (this.warehousesReady) {
        this.$emit('ready');
      }
    },
    dateRange() {
      this.filters.dateRange = this.dateRange;
    },
    filters: {
      handler() {
        this.$emit('change', this.filters);
      },
      deep: true
    }
  }
};
</script>
